import { render, staticRenderFns } from "./BeneficiaryView.vue?vue&type=template&id=bc8ec4a8&scoped=true&"
import script from "./BeneficiaryView.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8ec4a8",
  null
  
)

export default component.exports